'use strict';
//utils
var AppDispatcher = require('../core/AppDispatcher.jsx');
var EventEmitter = require('events').EventEmitter;
var assign = require('object-assign');
var _ = require('lodash');
var Mapper = require('../utils/Mapper.js');
var Products = require('../utils/Products.js');
var DateTime = require('../utils/DateTime.js');
var Formatter = require('../utils/Formatter.js');
var Validators = require('../utils/Validators.js');
var ContentService = require('../services/ContentService');
var Helper = require('../utils/FundingYourProductHelper.js');
var Helper2 = require('../utils/FundingYourProductHelperPart2.js');
var SelectCustomerActionsTypes = require('../constants/SelectCustomerConstants.js').ActionTypes;
var PensionPaymentStore = require('./PensionPaymentStore.js').default;

//constants
var AccountTypeConstants = require('../constants/AccountTypeConstants');
var ApplicationConstants = require('../constants/ApplicationConstants');
var Constants = require('../constants/FundingYourProductConstants');
var PensionConstants = require ('../constants/PensionTypeConstants.js');
var InSpecieTransferConstants = require('../constants/InSpecieTransferConstants.js');
var ApplicationActionTypes = ApplicationConstants.ActionTypes;
var PensionActionTypes = PensionConstants.ActionTypes;
var ActionTypes = Constants.ActionTypes;
var InSpecieActionTypes = InSpecieTransferConstants.ActionTypes;
var RollOverTypes = Constants.RollOverTypes;
var HowMuchToRollOver = Constants.HowMuchToRollOver;
var SectionNames = Constants.SectionNames;
var FundingTypes = Constants.FundingTypes;
var ContributionValues = Constants.ContributionValues;
var ExternalRollOverAttributes = Constants.ExternalRollOverAttributes;
var InternalRollOverAttributes = Constants.InternalRollOverAttributes;
var InternalTransferAttributes = Constants.InternalTransferAttributes;
var NonRollOverAttributes = Constants.NonRollOverAttributes;
var EligibleInSpecieAccounts = InSpecieTransferConstants.eligibleInSpecieProducts;

//local variables and functions
var CHANGE_EVENT = 'change';
var _summaryData = [];
var _productId = '';
var _activeFundType = '';
var _dataBeingEdited = '';
var _fundTypesVisibility = false;
var _isInputDirty = false;
var _newFundingType = _.cloneDeep(Constants.FundingTypeModel);
var _internalAccounts = [];
var _addedInternalAccounts = [];
var _rawBankAccounts = [];
var _bankAccounts = [];
var _dateOfBirth = '',
    _age;
var _setupErrorInfo = {
    valid: true,
    inline: '',
    summary: ''
}
var _sectionErrorList = [];
var _isEditMode = false;
var _editedIndex = '';
var _fundingTypes = [];
var _sectionName = '';
var _ripAnswer = ApplicationConstants.YesNoValues.NO;
var _selectedBankAccount = {
    bankAccountHeldOption: '',
    accountHolderName: '',
    branchNumber: '',
    accountNumber: '',
    bankAccountId: '',
    startDate: ''
};

var _internalAccountsCopy = [];
var _usiList = [];
var _externalProviderList = [];

var _internalRolloverInfo = {
    rolloverIndex: '',
    showRolloverDetails: false,
    showRolloverDetailsNew: false,
    disabledAddProduct: true
};
var _paymentMethodsInvestment = [];
var _clientOin = '', _client;
var _accountType = '';
var _crossSectionDependencyMsg = [];
var _isAtLeastOneInSpecieAccount = false;
var _isAtLeastOneContribution = false;
var _isAtLeastOneExternalButNoContrib = false;
var _inSpecieTransferOption;
var _pensionType = '';
var _downsizerContributionKillSwitch = true;

function setDownsizerContributionKillSwitch(response){
    _downsizerContributionKillSwitch = response && response.value === 'ON';
}

function prePopulateWithExistingClientIfAny() {
    if (!_client) {
        return;
    }
    setClientOin(_client.oin);

    // set date of birth
    if ((_productId === ApplicationConstants.ProductIds.SUPER || _productId === ApplicationConstants.ProductIds.PENSION)
        && _client.customerType === ApplicationConstants.ClientTypes.INDIVIDUAL) {
        setDateOfBirth(_client.dateOfBirth);
    }
}

//init section and cross-sectional dependencies
function appInit(productId) {
    resetGlobalVariables();
    _productId = productId;
    _sectionName = Mapper.getObjectByAttribute(SectionNames, _productId, 'id');
    generatePaymentMethodsInvestment();
    prePopulateWithExistingClientIfAny();
}

function resetGlobalVariables() {
    _summaryData = [];
    _activeFundType = '';
    _dataBeingEdited = '';
    _fundTypesVisibility = false;
    _isInputDirty = false;
    _newFundingType = _.cloneDeep(Constants.FundingTypeModel);
    _internalAccounts = [];
    _addedInternalAccounts = [];
    _rawBankAccounts = [];
    _bankAccounts = [];
    _dateOfBirth = '';
    _sectionErrorList = [];
    _isEditMode = false;
    _editedIndex = '';
    _fundingTypes = [];
    _internalRolloverInfo = {
        rolloverIndex: '',
        showRolloverDetails: false,
        showRolloverDetailsNew: false,
        disabledAddProduct: true
    };
    _paymentMethodsInvestment = [];
    _crossSectionDependencyMsg = [];
}

function setClient(client) {
    _client = _.cloneDeep(client);
}

function setFundingYourDetails(applicationData) {
    appInit(applicationData.productId);
    if (applicationData.form.regularInvestmentPlan) {
        setRipAnswer(applicationData.form.regularInvestmentPlan.ripOption);
    }
    _accountType = applicationData.form.accountType;
    if (applicationData && applicationData.form && applicationData.form.yourDetails) {
        if (Validators.requiredValidation(applicationData.form.yourDetails.dateOfBirth)) {
            setDateOfBirth(applicationData.form.yourDetails.dateOfBirth);
        }
        if (Validators.requiredValidation(applicationData.form.yourDetails.oin)) {
            setClientOin(applicationData.form.yourDetails.oin);
        }

        if (applicationData.form.yourDetails.occupation) {
            generateFundingTypes(_age);
        }
    }
    
    if (applicationData && applicationData.form && applicationData.form.fundingYourProduct) {
        _summaryData = [];
        _.each(applicationData.form.fundingYourProduct.fundingSources, fundingSource => {
            fundingSource.rollOverAmount = Formatter.currencyFormat(fundingSource.rollOverAmount ? fundingSource.rollOverAmount.toString() : '0');
            fundingSource.remainingBalance = Formatter.currencyFormat(fundingSource.remainingBalance ? fundingSource.remainingBalance.toString() : '0');
            fundingSource.productId = (fundingSource.isExistingAccount && !fundingSource.selectedManualEntryProductId)
                ? fundingSource.productId
                : Constants.ManualEntryInternalRolloverId;
            fundingSource.hideAmount = fundingSource.partialRolloverType === HowMuchToRollOver.ENTIRE_BALANCE;
            _summaryData.push(fundingSource);
        });
        if (Helper.checkIfDirectDebitExists(_summaryData)) {
            _summaryData = Helper.updateHideShowDirectDebitAddedText(_summaryData);
        }
        setNullPropertiesToEmpty();

        ////as part of r46.1 xplan prepopulation for funding details is not yet available
        ////xplan requirements: 
        //if (applicationData.originationSource &&
        //    applicationData.originationSource === ApplicationConstants.OriginationSources.IRESS) {
        //    //1. if application is retrieved from xplan and rollovers are present, if there are only internal rollovers present
        //    //but the application is not eligible for internal rollovers, the internal rollovers should be converted to external
        //    //rollovers
        //    _summaryData = Helper2.performInternalRolloverConversionIfRequired(_clientOin, _productId, _summaryData, _accountType);
        //    //2. if application is retrieved from xplan and rollovers are present, we need to show the first one in funding summary
        //    //in edit mode because xplan doesn't send the remaining balance of rollovers
        //    if (_summaryData.length === 1) {
        //        startEditMode(0, true);
        //    }
        //}
    }
}

function setNullPropertiesToEmpty() {
    _.forEach(_summaryData, function (n) {
        _.forOwn(n, function(value, key) {
            if (!value) {
                n[key] = '';
            }
        });
    });
}

function setClientOin(clientOin) {
    _clientOin = clientOin;
}

function setRipAnswer(answer) {
    _ripAnswer = answer;
}

function setDateOfBirth(dateOfBirth) {
    var isValid = DateTime.isBirthDateValid(dateOfBirth, _productId),
        isAge75Valid = DateTime.isAge75Valid(new Date(), dateOfBirth),
        copyText = ContentService.getContent().fundingYourProduct;
    _dateOfBirth = dateOfBirth? dateOfBirth : '';

    if (!_setupErrorInfo.valid && _dateOfBirth && isValid) {
        if ((_setupErrorInfo.inline === copyText.missingDOBInline && _setupErrorInfo.summary === copyText.missingDOBSummary)) {
            _setupErrorInfo.valid = true;
            _setupErrorInfo.inline = '';
            _setupErrorInfo.summary = '';
        }
    }

    if (isValid) {
        _age = DateTime.getAge(new Date(), dateOfBirth);
        generateFundingTypes(_age);

        if (_age > 75 || _age === 75 && isAge75Valid) {
            _.remove(_summaryData, function(n) { return n.rollOverType === FundingTypes.Personal_contribution || n.rollOverType === FundingTypes.Spouse_contribution; });
        }
    } else {
        _age = '';
    }
    if (!_activeFundType) {
        _fundTypesVisibility = false;
    }
}

function setClientAccounts(data, forRetrieve) {
    _internalAccounts = [];
    if (data && data.length > 0) {
        _internalAccounts = _.cloneDeep(data);
        _.forEach(_internalAccounts, function (n, index) {
            n.internalAccountIndex = index;
            n.hideInvestments = true;
            n.accountName = n.productName;
            n.accountBalance = Validators.isCurrency(n.balance.toString()) ? Formatter.currencyFormat(n.balance.toString()) : n.balance;
            _.forEach(n.investmentOptions, function (m) {
                m.balance = Validators.isCurrency(m.transactionAmount.toString()) ? Formatter.currencyFormat(m.transactionAmount.toString()) : m.transactionAmount;
            });
        });
        _internalAccountsCopy = _.cloneDeep(_internalAccounts);
    }
    if (forRetrieve) {
        if (_summaryData && _summaryData.length > 0) {
            _.each(_summaryData, item => {
                if (item.isExistingAccount) {
                    var existingAccount = _.find(_internalAccounts, function(x) {
                        return x.id === item.productId;
                    });
                    if (existingAccount) {
                        item.internalAccountIndex = existingAccount.internalAccountIndex;
                        _addedInternalAccounts.push(existingAccount);
                    }
                }
            });
        }

        if (_addedInternalAccounts.length > 0) {
            _.each(_addedInternalAccounts, added => {
                _.remove(_internalAccounts, function (n) { return n.internalAccountIndex === added.internalAccountIndex; });
            });
        }
    }
}

function validateDob(DOB, product) {
    var isValid = DateTime.isBirthDateValid(DOB, product);
    if (isValid) {
        _age = DateTime.getAge(new Date(), DOB);
        generateFundingTypes(_age);
    }
    return DateTime.isBirthDateValid(DOB, product);
}

function updateInvestmentVisibility(hideInvestments, index, isInternalAccounts) {
    if (isInternalAccounts) {
        _internalAccounts[index].hideInvestments = hideInvestments;
    } else {
        _summaryData[index].hideInvestments = hideInvestments;
    }
}

function clearNewFundingType(fromInternal) {
    if (_isInputDirty) {
        _isInputDirty = false;
    }
    if (fromInternal) {
        var newFundingTemp = _.cloneDeep(Constants.FundingTypeModel);
        newFundingTemp.paymentMethod = _newFundingType.paymentMethod;
        _newFundingType = newFundingTemp;
    } else {
        _newFundingType = _.cloneDeep(Constants.FundingTypeModel);
    }

    _setupErrorInfo.valid = true;
    _setupErrorInfo.inline = '';
    _setupErrorInfo.summary = '';
    _sectionErrorList = [];
}

function setActiveFundType(activeFundType) {
    _activeFundType = activeFundType;
}

function toggleFundingTypeVisibility() {
    _fundTypesVisibility = !_fundTypesVisibility;
}

//set bank account information
function setBankAccountList(data) {
    var bankData = [];
    _rawBankAccounts = _.cloneDeep(data);
    if (_rawBankAccounts) {
        var sq = 0;
        _.forEach(_rawBankAccounts, function (b) {
            var data = ({ accountHolder: b.bankAccountName, branchNumber: b.bankBsb, accountNumber: b.bankAccountNumber, value: b.bankAccountNumber, sq: sq++, id: b.bankAccountNumber });
            if (data.accountNumber && data.accountHolder && data.branchNumber) {
                bankData.push(data);
            }
        });
        if (bankData.length > 0) {
            bankData.push({
                accountHolder: 'Nominate another account',
                branchNumber: '',
                accountNumber: '',
                value: Constants.NominateBankAccountId,
                id: Constants.NominateBankAccountId,
                sq: ++sq
            });
            _bankAccounts = _.sortBy(bankData, function (o) { return o.sq });
        }
    }
}


function checkIfRollOverTypeExistsInSummary(rollOverType) {
    return Mapper.getObjectByAttribute(_summaryData, rollOverType, 'rollOverType');
}

function checkIfClaimTaxDeductionExistsInSummary() {
    return Mapper.getObjectByAttribute(_summaryData, ApplicationConstants.YesNoValues.YES, 'claimTaxDeduction');
}

//edit mode functions
function clearEditModeFlags() {
    _dataBeingEdited = '';
    _isInputDirty = false;
    _isEditMode = false;
    _editedIndex = '';
    if (!Helper.checkIfDirectDebitExists(_summaryData)) {
        setFirstBankAccount('');
    }
}

function prepareDataForEdit(dataToEdit) {
    if (!Helper.isNonRollover(dataToEdit.rollOverType) || Products.isInvestment(_productId) && Helper.isInternal(dataToEdit.paymentMethod)) {
        setInternalRolloverInfo(dataToEdit);
        var amtBal = parseFloat(dataToEdit.remainingBalance.toString().replace(/,/g, ''));
        var numBal = new Number(amtBal);
        var amt = parseFloat(dataToEdit.rollOverAmount.toString().replace(/,/g, ''));
        var num = new Number(amt);
        switch (dataToEdit.partialRolloverType) {
            case HowMuchToRollOver.ENTER_AMOUNT:
                dataToEdit.remainingBalance = numBal + num;
                dataToEdit.rollOverAmount = num;
                break;
            case HowMuchToRollOver.LEAVE_AMOUNT:
                dataToEdit.remainingBalance = numBal + num;
                dataToEdit.rollOverAmount = numBal;
                break;
            default:
                updateCrossSectionDependency(true);
                dataToEdit.remainingBalance = num;
                dataToEdit.rollOverAmount = 0;
                break;
        }
        dataToEdit.remainingBalance = Formatter.currencyFormat(dataToEdit.remainingBalance);
        dataToEdit.rollOverAmount = dataToEdit.partialRolloverType !== HowMuchToRollOver.ENTIRE_BALANCE ? Formatter.currencyFormat(dataToEdit.rollOverAmount) : '';
    }
    return dataToEdit;
}

function startEditMode(index, fromXplan) {
    _.forEach(_summaryData,
        function(n, index) {
            if (n.isEdit) {
                cancelEditMode(index);
            }
        });
    //create copy of data to be edited in case user opts to cancel;
    _editedIndex = index;
    _dataBeingEdited = _.cloneDeep(_summaryData[index]);
    _isEditMode = true;
    if (!fromXplan) {
        _summaryData[index] = prepareDataForEdit(_summaryData[index]);
    }
    _summaryData[index].isEdit = true;
    _summaryData[index].summaryIndex = index;
    _summaryData[index].hideInvestments = true;
    _isInputDirty = false;
    _fundTypesVisibility = false;
    setActiveFundType('');
    clearNewFundingType(false);
    if (Helper.isInternal(Products.isInvestment(_productId) ? _summaryData[index].paymentMethod :_summaryData[index].rollOverType)) {
        setInternalRolloverInfo(_summaryData[index]);
    }
}

function cancelEditMode(index) {
    //overwrite the current data being edited with the 'unedited' copy of data and delete the copy
    _summaryData[index] = _.cloneDeep(_dataBeingEdited);
    clearEditModeFlags();
}

function updateExistingRollOver(fieldId, value, index) {
    value = Mapper.toTrim(value);
    if (fieldId === 'rollOverAmount' || fieldId === 'remainingBalance') {
        if (value) {
            value = Validators.currencyValidation(value.toString()) ? Formatter.currencyFormatWithoutRounding(value.toString()) : value;
        }
    }
    if (fieldId === 'partialRolloverType') {
        _summaryData[index].hideAmount = value === HowMuchToRollOver.ENTIRE_BALANCE;
    }
    if ((fieldId === 'rollOverAmount' && _summaryData[index].rollOverAmount !== _dataBeingEdited.rollOverAmount) || 
        (fieldId === 'remainingBalance' && _summaryData[index].remainingBalance !== _dataBeingEdited.remainingBalance)) {
        updateCrossSectionDependency(true);
    }

    _summaryData[index][fieldId] = value;
    setBankAccountDetails(fieldId, value, _summaryData[index], true);

    if (_summaryData[index].hideDirectDebitAddedText) {
        setFirstBankAccount(_summaryData[index]);
        _.forEach(_summaryData, function (n) {
            if (Helper.isDirectDebit(n) && !n.hideDirectDebitAddedText) {
                getFirstBankAccountDetails(n);
            }
        });
    }
}

function submitUpdatedRollover(index) {
    _summaryData[index].isEdit = false;
    _summaryData[index].errorList = [];

    if (!Helper.isNonRollover(_summaryData[index].rollOverType)) {
        _summaryData[index] = Helper2.determineBalanceAndAmount(_summaryData[index]);
    }

    if (_summaryData[index].rollOverAmount !== _dataBeingEdited.rollOverAmount) {
        updateCrossSectionDependency(true);
    }

    if (Helper.isDirectDebit(_summaryData[index])) {
        processDirectDebit(_summaryData[index]);
    } else {
        clearDirectDebitInfo(_summaryData[index]);
    }

    if (!Helper.checkIfDirectDebitExists(_summaryData)) {
        setFirstBankAccount('');
    }
    clearEditModeFlags();
    clearNewFundingType(false);
    setActiveFundType('');
}

function clearDirectDebitInfo(dataToUpdate) {
    dataToUpdate.bankAccountHeldOption = '';
    dataToUpdate.accountHolderName = '';
    dataToUpdate.branchNumber = '';
    dataToUpdate.bankAccountId = '';
    dataToUpdate.startDate = '';
    dataToUpdate.showDdDetails= false;
    dataToUpdate.showDdNominateAccount= false;
    dataToUpdate.showBankAccountHeldText= false;
    if (Helper.isNonRollover(dataToUpdate.rollOverType)) {
        dataToUpdate.accountNumber = '';
    }
    if (dataToUpdate.hideDirectDebitAddedText) {
        _summaryData = Helper.updateHideShowDirectDebitAddedText(_summaryData);
    }
}
//validations
function getCustomAttributes(rollOverType, paymentMethod) {
    switch (rollOverType) {
        case RollOverTypes.EXTERNAL:
            return ExternalRollOverAttributes;
        case RollOverTypes.INTERNAL:
            return (paymentMethod === Constants.internalTransfer) ? InternalTransferAttributes : InternalRollOverAttributes;
        case RollOverTypes.NON_ROLLOVER:
            return NonRollOverAttributes;
        default:
            return {};
    }
}

function validateField(fieldId, rollOverType, dataToValidate, isEdit, nonRollover) {
    var rollover = nonRollover === RollOverTypes.NON_ROLLOVER ? RollOverTypes.NON_ROLLOVER : rollOverType;
    var customAttributes = getCustomAttributes(rollover, dataToValidate.paymentMethod);
    var rules = Helper.getValidationRules(rollover, fieldId, dataToValidate, _productId, _activeFundType);
    var isDirectDebit = false;
    if (rollover === RollOverTypes.NON_ROLLOVER) {
        isDirectDebit = Helper.isDirectDebit(dataToValidate);
    }
    if (!rules) {
        return;
    }
    var errorList = [];
    clearInlineValidations(dataToValidate, rollover, fieldId, isDirectDebit);
    Validators.validateField(dataToValidate, rules, customAttributes, errorList, fieldId);

    if (fieldId === 'accountNumber') {
        //perform duplicate account check
        Helper.duplicateAccountChecks(rollover, _summaryData, _internalAccountsCopy, dataToValidate, rollOverType, errorList, [], false, isEdit, {});
    }

    if (fieldId === 'rollOverAmount') {
        Helper.performBalanceAndAmountValidation(rollover, dataToValidate, rollOverType, errorList, [], false, {});
    }

    if (errorList.length > 0) {
        errorList = Helper.mapInlineErrorList(errorList, rollover, isDirectDebit);
        _.forEach(errorList, function (n) {
            //only add new inline errors
            var existingError = _.find(dataToValidate.errorList, { 'id': n.id, 'message': n.message });
            if (!existingError) {
                if (dataToValidate.errorList) {
                    dataToValidate.errorList.push(n);
                } else {
                    _.assign(dataToValidate, { errorList: [n] });
                }
            }
        });
    }
}

function clearInlineValidations(dataToValidate, rollOver, fieldId, isDirectDebit) {
    //clear validation from field
    Validators.clearErrorListForField(dataToValidate.errorList, Helper.getFieldMapping(rollOver, fieldId, isDirectDebit));
}

function validateSetup(validateForm) {
    var copyText = ContentService.getContent().fundingYourProduct;
    if (!validateDob(_dateOfBirth, _productId) && (_productId === ApplicationConstants.ProductIds.SUPER || _productId === ApplicationConstants.ProductIds.PENSION)) {
        _setupErrorInfo.valid = false;
        _setupErrorInfo.inline = copyText.missingDOBInline;
        _setupErrorInfo.summary = copyText.missingDOBSummary;
    } else {
        _setupErrorInfo.valid = true;
        _setupErrorInfo.inline = '';
        _setupErrorInfo.summary = '';
        generateFundingTypes(_age);
    }

    if (validateForm && !_setupErrorInfo.valid) {
        var sectionName = _sectionName;
        _sectionErrorList.push({
            clickable: sectionName.label,
            message: _setupErrorInfo.summary,
            id: 'fundingYourProductSection'
        });
    }
}

function validateRollOver(rollOverType, dataToValidate, isEdit, validateForm, nonRollover) {
    var inlineErrorList, summaryErrorList = [];
    var rollover = nonRollover === RollOverTypes.NON_ROLLOVER ? RollOverTypes.NON_ROLLOVER : rollOverType;
    var customAttributes = getCustomAttributes(rollover, dataToValidate.paymentMethod);
    var rules = Helper.getValidationRules(rollover, '', dataToValidate, _productId, _activeFundType);
    var sectionName = _sectionName;
    var isDirectDebit = false;
    if (rollover === RollOverTypes.NON_ROLLOVER) {
        isDirectDebit = Helper.isDirectDebit(dataToValidate);
    }
    if (validateForm) {
        summaryErrorList = Validators.validateAll(dataToValidate, rules, customAttributes, '', sectionName.label);
    }
    inlineErrorList = Validators.validateAll(dataToValidate, rules, customAttributes);

    Helper.performBalanceAndAmountValidation(rollover, dataToValidate, rollOverType, inlineErrorList, summaryErrorList, validateForm, sectionName.label);

    //perform duplicate account check
    Helper.duplicateAccountChecks(rollover, _summaryData, _internalAccountsCopy, dataToValidate, rollOverType, inlineErrorList, summaryErrorList, validateForm, isEdit, sectionName.label);

    if (!isEdit) {
        // check if internal and external fundings exceeds to 20
        Helper.rollOverLimitValidation(rollOverType, _summaryData, inlineErrorList, summaryErrorList, validateForm, sectionName.label);
        //restrict funding sources for investment to just 1 because pdf template can handle only one handle 1 funding source.
        Helper.checkInvestmentNumberOfFundingSources(_productId, _summaryData, inlineErrorList, summaryErrorList, validateForm, sectionName.label);
    }

    summaryErrorList = Helper.sortSummaryErrorMessages(summaryErrorList);

    // direct debit validations
    Helper.directDebitValidation(dataToValidate, isDirectDebit, summaryErrorList, validateForm, sectionName.label);

    Helper.mapSummaryErrorList(_sectionErrorList, summaryErrorList, validateForm, sectionName.label, rollover, isDirectDebit);

    if (inlineErrorList.length > 0) {
        inlineErrorList = Helper.mapInlineErrorList(inlineErrorList, rollover, isDirectDebit);
        dataToValidate.errorList = inlineErrorList;
    }
    else if (isDirectDebit && !dataToValidate.hideBankAccountListValid) {
        inlineErrorList = Helper.mapInlineErrorList(inlineErrorList, rollover, isDirectDebit);
        dataToValidate.errorList = inlineErrorList;
    }
    else {
        if (!validateForm) {
            if (isEdit) {
                submitUpdatedRollover(dataToValidate.summaryIndex);
            } else {
                submitNewRollover(rollOverType);
            }
        }
        _setupErrorInfo.valid = true;
        _setupErrorInfo.inline = '';
        _setupErrorInfo.summary = '';
    }
}

function validateSection() {
    if (!Products.isAnnuity(_productId)) {
        var copyText = ContentService.getContent().fundingYourProduct;
        var isInvestment = Products.isInvestment(_productId);
        var isPension = Products.isPension(_productId);
        //clear existing section errors
        _sectionErrorList = [];

        //validate pre conditions for funding your product
        validateSetup(true);
        //funding type required validation
        if (!_setupErrorInfo.valid) {
            _fundTypesVisibility = false;
            _activeFundType = '';
            _newFundingType.errorList = [];
        }
        if (_setupErrorInfo.valid && _summaryData.length === 0) {
            if ((!isInvestment && !Validators.requiredValidation(_activeFundType)) || (isInvestment && !Validators.requiredValidation(_newFundingType.paymentMethod))) {
                _setupErrorInfo.valid = false;
                _setupErrorInfo.inline = copyText.requiredFundingInline;
                _sectionErrorList.push({
                    clickable: _sectionName.label,
                    message: copyText.requiredFundingSummary,
                    id: 'fundingYourProductSection'
                });
            }
        }

        //validate totals
        if (_setupErrorInfo.valid && _summaryData.length> 0 && (isInvestment || isPension)) {
            var result = Helper.validateTotals(getTotal(), _productId, _ripAnswer, _sectionName.label);
            if (result.newErrorList.length > 0) {
                _setupErrorInfo.valid = false;
                _setupErrorInfo.inline = result.newErrorList[0].message;
                _sectionErrorList.push(result.newSummaryErrorList[0]);
            }
        }
        
        if (isInvestment) {
            if (Validators.requiredValidation(_newFundingType.paymentMethod)) {
                switch (_newFundingType.paymentMethod) {
                    case ContributionValues.INTERNAL_TRANSFER:
                        if (Validators.requiredValidation(_newFundingType.productId)) {
                            validateRollOver(RollOverTypes.INTERNAL, _newFundingType, false, true);
                        }
                        break;
                    default:
                        validateRollOver(RollOverTypes.NON_ROLLOVER, _newFundingType, false, true);
                        break;
                }
            }
        } else {
            //validate currently active fund type
            if (_activeFundType) {
                switch (_activeFundType) {
                    case FundingTypes.Internal_rollover:
                        if (_isInputDirty) {
                            validateRollOver(RollOverTypes.INTERNAL, _newFundingType, false, true);
                        } else {
                            if (!_newFundingType.productId) {
                                _setupErrorInfo.valid = false;
                                _setupErrorInfo.inline = copyText.noInternalAccountSelectedInline;
                                _sectionErrorList.push({
                                    clickable: _sectionName.label,
                                    message: copyText.requiredFundingSummary,
                                    id: 'fundingYourProductSection'
                                });
                            }
                        }
                        break;
                    case FundingTypes.External_rollover:
                        validateRollOver(RollOverTypes.EXTERNAL, _newFundingType, false, true);
                        break;
                    default:
                        validateRollOver(RollOverTypes.NON_ROLLOVER, _newFundingType, false, true);
                        break;
                }
            }
        }
        if (_isEditMode) {
            var nonRollOver = Helper.isNonRollover(_summaryData[_editedIndex].rollOverType) ? RollOverTypes.NON_ROLLOVER : _summaryData[_editedIndex].rollOverType;
            validateRollOver(_summaryData[_editedIndex].rollOverType, _summaryData[_editedIndex], true, true, nonRollOver);
        }

        if (_setupErrorInfo.valid && (_isInputDirty || _isEditMode)) {
            _setupErrorInfo.valid = false;
            _setupErrorInfo.inline = copyText.completeFundingInline;
            _sectionErrorList.push({
                clickable: _sectionName.label,
                message: copyText.requiredFundingSummary,
                id: 'fundingYourProductSection'
            });
        }
    }
}

//new funding type methods
function updateNewRollOver(fieldId, value, rollOverType) {
    //disable select fund type dropdown if input is not dirty
    if (!_isInputDirty) {
        _isInputDirty = true;
    }
    value = Mapper.toTrim(value);
    if (fieldId === 'rollOverAmount' || fieldId === 'remainingBalance') {
        if (value) {
            value = Validators.currencyValidation(value.toString()) ? Formatter.currencyFormatWithoutRounding(value.toString()) : value;
        }
    }
    _newFundingType[fieldId] = value;
    if (fieldId === 'partialRolloverType') {
        _newFundingType.hideAmount = value === HowMuchToRollOver.ENTIRE_BALANCE;
    }
    setBankAccountDetails(fieldId, value, _newFundingType, false);
    //set rollOverType on first update call
    if (_newFundingType.rollOverType === '') {
        _newFundingType.rollOverType = rollOverType;
    }
}

function setBankAccountDetails(fieldId, value, dataToUpdate, isEdit) {
    if (fieldId === 'paymentMethod' && value === ContributionValues.DIRECT_D) {
        //if there are no bank accounts and no direct debit sources have been added
        //display nominate account details
        if (_bankAccounts.length === 0){
            dataToUpdate.bankAccountId = Constants.NominateBankAccountId;
            dataToUpdate.showDdDetails = true;
            dataToUpdate.showDdNominateAccount = true;
        }

        //if a direct debit source has already been added
        //use the same bank details for the next direct debit sources
        if (isEdit) {
            if (Helper.checkIfDirectDebitExists(_summaryData) &&
                !Helper.isDirectDebit(_dataBeingEdited) &&
                Validators.requiredValidation(_selectedBankAccount.bankAccountId)) {
                dataToUpdate = getFirstBankAccountDetails(dataToUpdate);
            }
        } else {
            if (Helper.checkIfDirectDebitExists(_summaryData)) {
                dataToUpdate = getFirstBankAccountDetails(dataToUpdate);
            }
        }
    } else if (fieldId === 'paymentMethod' && value !== ContributionValues.DIRECT_D) {
        dataToUpdate.hideDirectDebitAddedText = true;
    }


    if (fieldId === 'bankAccountId') {
        dataToUpdate.showDdDetails = true;
        if (value === Constants.NominateBankAccountId) {
            dataToUpdate.showDdNominateAccount = true;
        } else {
            dataToUpdate.showDdNominateAccount = false;
        }
        setExistingBankAccountDetails(value, dataToUpdate);
    }

    if (fieldId === 'bankAccountHeldOption') {
        if (value === ApplicationConstants.YesNoValues.NO) {
            dataToUpdate.showBankAccountHeldText = true;
        } else {
            dataToUpdate.showBankAccountHeldText = false;
        }
    }
}

function getFirstBankAccountDetails(dataToUpdate) {
    dataToUpdate.bankAccountHeldOption = _selectedBankAccount.bankAccountHeldOption;
    dataToUpdate.accountHolderName = _selectedBankAccount.accountHolderName;
    dataToUpdate.branchNumber = _selectedBankAccount.branchNumber;
    dataToUpdate.accountNumber = _selectedBankAccount.accountNumber;
    dataToUpdate.bankAccountId = _selectedBankAccount.bankAccountId;
    dataToUpdate.startDate = _selectedBankAccount.startDate;
    dataToUpdate.showDdDetails = false;
    dataToUpdate.showDdNominateAccount = false;
    dataToUpdate.hideDirectDebitAddedText = false;
    return dataToUpdate;
}

function setExistingBankAccountDetails(value, dataToUpdate) {
    if (value !== Constants.NominateBankAccountId) {
        dataToUpdate.bankAccountHeldOption = ApplicationConstants.YesNoValues.YES;
        var selectedBankAccount = _.find(_bankAccounts, { 'accountNumber': value });
        dataToUpdate.accountHolderName = selectedBankAccount.accountHolder;
        dataToUpdate.branchNumber = selectedBankAccount.branchNumber;
        dataToUpdate.accountNumber = value;
    } else {
        dataToUpdate.bankAccountHeldOption = '';
        dataToUpdate.accountHolderName = '';
        dataToUpdate.branchNumber = '';
        dataToUpdate.accountNumber = '';
    }
    dataToUpdate.hideBankAccountListValid = true;
    dataToUpdate.bankAccountId = value;
}

function submitNewRollover(rollOverType) {
    var isInternalTransfer = Products.isInvestment(_productId) && Helper.isInternal(_newFundingType.paymentMethod);

    rollOverType = isInternalTransfer ? RollOverTypes.INTERNAL : rollOverType;
    _newFundingType.rollOverType = rollOverType;
    _newFundingType.summaryIndex = _summaryData.length;
    _newFundingType.errorList = [];
    if (!Helper.isNonRollover(rollOverType) || isInternalTransfer) {
        _newFundingType = Helper2.determineBalanceAndAmount(_newFundingType);
    }

    if (_newFundingType.isExistingAccount) {
        processExistingAccount(_newFundingType.internalAccountIndex);
    }
    if (Helper.isDirectDebit(_newFundingType)) {
        processDirectDebit(_newFundingType);
    }
    _summaryData.push(_newFundingType);

    updateCrossSectionDependency(false);

    setActiveFundType('');
    clearNewFundingType(false);
    toggleFundingTypeVisibility();
}

function updateCrossSectionDependency(isEdit) {
    var content = ContentService.getContent();
    _crossSectionDependencyMsg = [];
    if (Products.isPension(_productId) && !isEdit) {
        var isAtLeastOneInSpecieAccount = _.some(_summaryData, function (o) {
            let isInSpecie = false;
            _.forEach(EligibleInSpecieAccounts, function (eligibleProductId) {
                let pid = o.isExistingAccount ? o.productId : o.selectedManualEntryProductId;
                if (pid === eligibleProductId) {
                    isInSpecie = true;
                }
            });
            return isInSpecie;
        });

        if (isAtLeastOneInSpecieAccount !== _isAtLeastOneInSpecieAccount) {
            // inspecie section will switch between visible and invisible
            _crossSectionDependencyMsg.push({ content: content.crossSectionHeaders.inSpecieTransfer, order: 1 });
            _inSpecieTransferOption = ApplicationConstants.YesNoValues.NO;
        } else if (isAtLeastOneInSpecieAccount && _inSpecieTransferOption !== ApplicationConstants.YesNoValues.NO) {
            _crossSectionDependencyMsg.push({ content: content.crossSectionHeaders.inSpecieTransfer, order: 1 });
            _inSpecieTransferOption = ApplicationConstants.YesNoValues.NO;
        }

        var isAtLeastOneContribution = _.some(_summaryData, function (o) {
            return o.rollOverType === FundingTypes.Spouse_contribution ||
                o.rollOverType === FundingTypes.Personal_contribution ||
                o.rollOverType === FundingTypes.Personal_injury_payment ||
                o.rollOverType === FundingTypes.CGT_contribution ||
                o.rollOverType === FundingTypes.Downsizer_contribution;
        });

        var isAtLeastOneExternalButNoContrib = _.some(_summaryData, { 'rollOverType': RollOverTypes.EXTERNAL }) && !isAtLeastOneContribution;

        if (isAtLeastOneContribution !== _isAtLeastOneContribution ||
            isAtLeastOneExternalButNoContrib !== _isAtLeastOneExternalButNoContrib) {
            _crossSectionDependencyMsg.push({ content: content.crossSectionHeaders.superFirstTransfer, order: 2 });
        }

        _isAtLeastOneInSpecieAccount = isAtLeastOneInSpecieAccount;
        _isAtLeastOneExternalButNoContrib = isAtLeastOneExternalButNoContrib;
        _isAtLeastOneContribution = isAtLeastOneContribution;
    }
}

function processDirectDebit(dataToUpdate) {
    if (!Helper.checkIfDirectDebitExists(_summaryData) &&
        !Validators.requiredValidation(_selectedBankAccount.bankAccountId)) {
        setFirstBankAccount(dataToUpdate);
    }
}

function processExistingAccount(internalAccountIndex) {
    var currentAccount = _.find(_internalAccounts, function (n) {
        return n.internalAccountIndex === internalAccountIndex;
    });
    //add the investment options of the existing account to the copy of the data in the summary
    _newFundingType.investmentOptions = _.cloneDeep(currentAccount.investmentOptions);
    //if its existing account, remove it from the list of existing accounts
    _addedInternalAccounts.push(currentAccount);
    _.remove(_internalAccounts, function (n) { return n.internalAccountIndex === internalAccountIndex; });
}
//delete
function removeFromSummary(index) {
    if (Helper.isDirectDebit(_summaryData[index])) {
        removeDirectDebitFromSummary(index);
    } else {
        removeExistingAccountFromSummary(index);
        _summaryData.splice(index, 1); //delete
        _summaryData = Helper.updateSummaryIndex(_summaryData);
    }
    if (!Helper.checkIfDirectDebitExists(_summaryData)) {
        setFirstBankAccount('');
    }

    updateCrossSectionDependency(false);

    setActiveFundType('');
    clearNewFundingType(false);
    _fundTypesVisibility = false;
}

//if existing account, return it to the list of existing accounts
function removeExistingAccountFromSummary(index) {
    if (_summaryData[index].isExistingAccount) {
        var addExistingAccount = _.find(_addedInternalAccounts, function (n) {
            return n.internalAccountIndex === _summaryData[index].internalAccountIndex;
        });
        _internalAccounts.splice(addExistingAccount.internalAccountIndex, 0, addExistingAccount);
        _.remove(_addedInternalAccounts, function(a) {
            return a.internalAccountIndex === addExistingAccount.internalAccountIndex;
        })
    }
}

//if direct debit funding type/contribution and it is the only direct debit funding type/contribution
//we need to display the bank account list and/or nominate bank account details
function removeDirectDebitFromSummary(index) {
    _summaryData = Helper.removeDirectDebitFromSummary(index, _summaryData);
}

function setFirstBankAccount(data) {
    if (data !== '') {
        _selectedBankAccount.bankAccountHeldOption = data.bankAccountHeldOption;
        _selectedBankAccount.accountHolderName = data.accountHolderName;
        _selectedBankAccount.branchNumber = data.branchNumber;
        _selectedBankAccount.accountNumber = data.accountNumber;
        _selectedBankAccount.bankAccountId = data.bankAccountId;
        _selectedBankAccount.startDate = data.startDate;
    } else {
        _selectedBankAccount.bankAccountHeldOption = '';
        _selectedBankAccount.accountHolderName = '';
        _selectedBankAccount.branchNumber = '';
        _selectedBankAccount.accountNumber = '';
        _selectedBankAccount.bankAccountId = '';
        _selectedBankAccount.startDate = '';
    }
}

function generateFundingTypes(age) {
    var fundingData,
        eligibleContribution;

    if (age>=0) {
        eligibleContribution = 
        DateTime.eligibleContributionMatrix(
            age, _dateOfBirth, _downsizerContributionKillSwitch);
    }

    fundingData = Helper2.checkIfApplicantIsEligibleForInternalRollovers(_clientOin)
        ? Constants.SelectFundingTypes
        : Constants.FundingTypesNoInternalRollover;

    // Pension + Death Benefit ==> only 2 funding types are allowed
    if (Products.isPension(_productId) &&
        _pensionType === PensionConstants.PensionTypeBenefits.ENTRY_DEATH) {
        fundingData = _.reject(fundingData, function (o) {
            return !(o.value === Constants.FundingTypes.Internal_rollover ||
                     o.value === Constants.FundingTypes.External_rollover);
        });
    }

    //If Personal or Spouse are TRUE then we go to this process otherwise we skip this condition.
    if (eligibleContribution) {
        var data = fundingData;

        if (eligibleContribution.hideDownsizer) {
            data = _.reject(data, function (o) {
                return o.value === Constants.FundingTypes.Downsizer_contribution;
            });
        }

        if (eligibleContribution.hidePersonal || eligibleContribution.hideSpouse) {
            if (eligibleContribution.hidePersonal) {
                data = _.reject(data, function (o) {
                    return o.value === Constants.FundingTypes.Personal_contribution;
                });
            }

            if (eligibleContribution.hideSpouse) {
                data = _.reject(data, function (o) {
                    return o.value === Constants.FundingTypes.Spouse_contribution;
                });
            }
        }
        //remove from dropdown if other contribution type is already in summary
        if (_summaryData.length > 0) {
            var tempData = data;

            _.forEach(_summaryData, function (i) {
                tempData = _.reject(tempData, { value: i.rollOverType });
            });

            return _fundingTypes = tempData;
        }

        return _fundingTypes = data;
    }

    return _fundingTypes = fundingData;
}

function getTotal() {
    var nonEditedSummary = _.where(_summaryData, function(o){ return o.isEdit !== true });
    var rollovers = _.map(nonEditedSummary, 'rollOverAmount');
    var total = 0;
    for (var i = 0; i < rollovers.length; i++) {
        if (Validators.requiredValidation(rollovers[i])) {
            total = total + Mapper.toCurrency(rollovers[i]);
        }
    }
    return total;
}

function setInternalRolloverInfo(data) {
    _internalRolloverInfo.rolloverIndex = data.rolloverIndex;
    _internalRolloverInfo.showRolloverDetails = data.showRolloverDetails;
    _internalRolloverInfo.showRolloverDetailsNew = data.showRolloverDetailsNew;
    _internalRolloverInfo.disabledAddProduct = data.disabledAddProduct;

    if (_isEditMode) {
        if (checkIfRollOverTypeExistsInSummary(RollOverTypes.INTERNAL)) {
            _internalRolloverInfo.showRolloverDetails = true;
            _internalRolloverInfo.showRolloverDetailsNew = true;
        }
        if (_newFundingType.productId === Constants.ManualEntryInternalRolloverId) {
            _internalRolloverInfo.disabledAddProduct = false;
        }
    }
}

function updateInternalAccountDetails(data) {
    _newFundingType.isExistingAccount = data.isExistingAccount;
    _newFundingType.productId = data.productId;
    _newFundingType.internalAccountIndex = data.internalAccountIndex;
    _newFundingType.rollOverName = data.rollOverName;
    _newFundingType.accountNumber = data.accountNumber;
    _newFundingType.remainingBalance = data.remainingBalance;
    _newFundingType.errorList = [];
}

function generatePaymentMethodsInvestment() {
    _paymentMethodsInvestment = Helper2.checkIfApplicantIsEligibleForInternalTransfers(_clientOin, _accountType)
        ? Constants.WithInternalTransfer
        : Constants.NoInternalTransfer;
}

function checkIfDirectDebitExists() {
    return Mapper.getObjectByAttribute(_summaryData, ContributionValues.DIRECT_D, 'paymentMethod');
}
function setUsiList(data) {
    _usiList = _.cloneDeep(data);
    _usiList.map(function (obj) {
        _externalProviderList.push({
            value: obj.usi,
            label: obj.usi + ' - ' + obj.productName,
            productName: obj.productName,
            usi: obj.usi,
            abn: obj.abn,
            isActive: obj.isActive
        });
    });
}

function updateExternalPredictiveDetails(data) {
    var dataToUpdate = _newFundingType;
    if (data.index > -1) {
        dataToUpdate = _summaryData[data.index];
    }
    dataToUpdate.rollOverNamePredictive = data.predictiveName;
    dataToUpdate.usi = data.usi;
    dataToUpdate.isExternalProviderManualEntry = data.isExternalProviderManualEntry;
    dataToUpdate.rollOverName = '';
    Validators.clearErrorListForField(dataToUpdate.errorList, 'fypExternalRolloverProvider2');
}

function setInSpecieTransferOption(fieldId, value) {
    if (fieldId !== 'setUp') return;
    _inSpecieTransferOption = value;
}

function sortCrossSectionOrder() {
    _crossSectionDependencyMsg = _.sortBy(_crossSectionDependencyMsg, 'order');
}

function pensionTypeChanged(pensionType) {
    // when switch from/to Death benefit, funding types have to be refreshed    
    if (pensionType !== _pensionType &&
        (pensionType === PensionConstants.PensionTypeBenefits.ENTRY_DEATH ||
        _pensionType === PensionConstants.PensionTypeBenefits.ENTRY_DEATH ||
        pensionType === PensionConstants.PensionTypeSelectionNames.PRE_RETIREMENT ||
        _pensionType === PensionConstants.PensionTypeSelectionNames.PRE_RETIREMENT)) {
        _pensionType = pensionType;
        generateFundingTypes(_age);
        _summaryData = [];
        
        setInternalRolloverInfo({
            rolloverIndex: '',
            showRolloverDetails: false,
            showRolloverDetailsNew: false,
            disabledAddProduct: true
        });
        _activeFundType = '';
        _fundTypesVisibility = false;
        _isInputDirty = false;
    } else {
        _pensionType = pensionType;
    }
}

var FundingYourProductStore = assign({},
    EventEmitter.prototype,
    {
    emitChange: function () {
        return setTimeout(()=>this.emit(CHANGE_EVENT), 0);
    },

    /**
     * @param {function} callback
     */
    addChangeListener: function (callback) {
        this.on(CHANGE_EVENT, callback);
    },

    /**
     * @param {function} callback
     */
    removeChangeListener: function (callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },

    getTotalRollovers: function () {
        return getTotal();
    },

    getActiveFundType: function () {
        if (Products.isInvestment(_productId)) {
            return FundingTypes.CGT_contribution;
        }
        return _activeFundType;
    },

    getSummaryData: function () {
        return _.cloneDeep(_summaryData);
    },

    getIsInputDirty: function () {
        return _isInputDirty;
    },

    getFundTypeVisibility: function () {
        return _fundTypesVisibility;
    },

    getNewFundingType: function () {
        return _newFundingType;
    },

    getInternalAccounts: function () {
        return _internalAccounts;
    },

    getSetupErrorInfo: function () {
        return _setupErrorInfo;
    },

    getSectionErrors: function () {
        return _sectionErrorList;
    },

    getHasExternalRollover: function () {
        if (checkIfRollOverTypeExistsInSummary(RollOverTypes.EXTERNAL)) {
            return true;
        } else {
            return false;
        }
    },

    getHasInternalRollover: function () {
        if (checkIfRollOverTypeExistsInSummary(RollOverTypes.INTERNAL)) {
            return true;
        } else {
            return false;
        }
    },

    clearSummary: function () {
        _summaryData = [];
    },

    getIsEditMode: function () {
        return _isEditMode;
    },

    getInternalRolloverInfo: function () {
        return _internalRolloverInfo;
    },

    showEnterLeaveAmount: function () {
        return (_dataBeingEdited.partialRolloverType === HowMuchToRollOver.ENTER_AMOUNT || _dataBeingEdited.partialRolloverType === HowMuchToRollOver.LEAVE_AMOUNT) ? true : false;
    },
    otherInvestmentOptionChecked: function () {
        return (_dataBeingEdited.otherInvestmentOptionChecked);
    },

    getFundingTypes: function () {
        if (!this.getDownsizerContributionSwitch().killSwitch) {
            _fundingTypes = _.reject(_fundingTypes, function (o) {
                return o.value === Constants.FundingTypes.Downsizer_contribution;
            });
        }

        return _fundingTypes;
    },

    getHasPersonalContribution: function () {
        if (Products.isPension(_productId)) {
            if (checkIfClaimTaxDeductionExistsInSummary()) {
                return true;
            }
        }
        else if (checkIfRollOverTypeExistsInSummary(FundingTypes.Personal_contribution)) {
            return true;
        }
        return false;

    },

    getBankAccounts: function () {
        return _bankAccounts;
    },

    getFypFormModel: function () {
        var formModel = {
            fundingSources: [],
            totalAmount: 0
        };
        formModel.totalAmount = getTotal();
        _.forEach(_summaryData,
            function (n) {
                var newFundSource = _.omit(n,
                [
                    'showDdDetails',
                    'showDdNominateAccount',
                    'hideBankAccountListValid',
                    'showBankAccountHeldText',
                    'hideDirectDebitAddedText',
                    'isExistingAccount:false',
                    'errorList',
                    'errorListForSummary',
                    'hideInvestments',
                    'isEdit',
                    'hideAmount'
                ]);
                formModel.fundingSources.push(newFundSource);
            });
        return formModel;
    },
    getPaymentMethodsInvestment: function () {
        return _paymentMethodsInvestment;
    },
    getHasDirectDebit: function () {
        if (checkIfDirectDebitExists()) {
            return true;
        } else {
            return false;
        }
    },
    getUsiList: function () {
        return _externalProviderList;
    },
    getCrossSectionDependencyMsg: function () {
        sortCrossSectionOrder();
        return _crossSectionDependencyMsg;
    },
    getIsFundingSourceVisible: function () {
        return !(Products.isPension(_productId) &&
            _pensionType === PensionConstants.PensionTypeBenefits.ENTRY_DEATH &&
            _summaryData.length > 0);
    },
    getIsDeathBenefit: function () {
        return Products.isPension(_productId) &&
            _pensionType === PensionConstants.PensionTypeBenefits.ENTRY_DEATH;
    },
    getDownsizerContributionSwitch() {
        return {
            killSwitch: _downsizerContributionKillSwitch
        };
    }
});

FundingYourProductStore.dispatchToken = AppDispatcher.register(function (action) {

    switch (action.actionType) {
        case SelectCustomerActionsTypes.SET_CLIENT_OIN:
            setClientOin(action.clientOin);
            break;
        case ApplicationActionTypes.VALIDATE_APPLICATION:
            validateSection();
            break;
        case ApplicationActionTypes.APPLICATION_RETRIEVE_SUCCESS:
            AppDispatcher.waitFor([PensionPaymentStore.dispatchToken]);
            setFundingYourDetails(action.applicationData);
            break;
        case ApplicationActionTypes.NEW_APPLICATION_INITIALISED:
            appInit(action.productId);
            break;
        case ActionTypes.UPDATE_INVESTMENTS_VISIBILITY:
            updateInvestmentVisibility(action.hideInvestments, action.index, action.isInternalAccounts);
            break;
        case ActionTypes.SET_ACTIVE_FUND_TYPE:
            setActiveFundType(action.data);
            clearNewFundingType(false);
            break;
        case ActionTypes.START_EDIT_FUNDING_TYPE:
            startEditMode(action.index, false);
            break;
        case ActionTypes.CANCEL_EDIT_FUNDING_TYPE:
            cancelEditMode(action.index);
            break;
        case ActionTypes.END_EDIT_FUNDING_TYPE:
            validateRollOver(_summaryData[action.index].rollOverType, _summaryData[action.index], true, false, RollOverTypes.ROLLOVER);
            break;
        case ActionTypes.TOGGLE_FUNDING_TYPE_VISIBILITY:
            toggleFundingTypeVisibility();
            break;
        case ActionTypes.UPDATE_NEW_ROLLOVER:
            updateNewRollOver(action.fieldId, action.value, action.rollOverType);
            validateField(action.fieldId, action.rollOverType, _newFundingType, false, action.nonRollover);
            break;
        case ActionTypes.SUBMIT_NEW_EXTERNAL_ROLLOVER:
            validateRollOver(RollOverTypes.EXTERNAL, _newFundingType, false, false, RollOverTypes.ROLLOVER);
            break;
        case ActionTypes.SUBMIT_INTERNAL_ROLLOVER:
            validateRollOver(RollOverTypes.INTERNAL, _newFundingType, false, false, RollOverTypes.ROLLOVER);
            break;
        case ActionTypes.DELETE_FUNDING_TYPE:
            removeFromSummary(action.index);
            break;
        case ApplicationActionTypes.SEND_YOUR_DETAIL_DOB:
            setDateOfBirth(action.dob);
            break;
        case ActionTypes.VALIDATE_FUNDING_SECTION_SETUP:
            validateSetup();
            break;
        case ActionTypes.UPDATE_EXISTING_ROLLOVER:
            updateExistingRollOver(action.fieldId, action.value, action.index);
            validateField(action.fieldId, action.rollOverType, _summaryData[action.index], true, RollOverTypes.ROLLOVER);
            break;
        case ApplicationActionTypes.SEND_CLIENT_ACCOUNT_DETAILS:
            setClientAccounts(action.data, action.forRetrieve);
            break;
        case ActionTypes.CLEAR_NEW_FUNDING_TYPE:
            clearNewFundingType(action.fromInternal);
            break;
        case ActionTypes.SUBMIT_OTHER_FUND_TYPE:
            validateRollOver(action.rollOverType, _newFundingType, false, false, RollOverTypes.NON_ROLLOVER);
            break;
        case ActionTypes.END_EDIT_NON_ROLLOVER:
            validateRollOver(_summaryData[action.index].rollOverType, _summaryData[action.index], true, false, RollOverTypes.NON_ROLLOVER);
            break;
        case ApplicationConstants.ActionTypes.SEND_BANK_ACCOUNT_DETAILS:
            setBankAccountList(action.data);
            break;
        case ActionTypes.SET_INTERNAL_ROLLOVER_INFO:
            setInternalRolloverInfo(action.data);
            break;
        case ActionTypes.UPDATE_INTERNAL_ACCOUNT_DETAILS:
            updateInternalAccountDetails(action.data);
            break;
        case ApplicationActionTypes.SEND_RIP_ANSWER:
            setRipAnswer(action.answer);
            break;
        case AccountTypeConstants.ActionTypes.SELECT_ACCOUNT_TYPE:
            _accountType = action.accountType;
            generatePaymentMethodsInvestment();
            break;
        case ActionTypes.LOAD_SUPER_FUND_LIST:
            setUsiList(action.data);
            break;
        case ActionTypes.UPDATE_EXTERNAL_PREDICTIVE_DETAILS:
            updateExternalPredictiveDetails(action.data);
            break;
        case InSpecieActionTypes.UPDATE_INSPECIE_MODEL:
            setInSpecieTransferOption(action.fieldId, action.value);
            break;
        case SelectCustomerActionsTypes.CLIENT_RETRIEVE_COMPLETED:
            setClient(action.client);
            break;
        case PensionActionTypes.SELECT_BENEFIT:
        case PensionActionTypes.SELECT_PENSION_TYPE:
            pensionTypeChanged(action.value);
            break;
        case ApplicationConstants.ActionTypes.DOWNSIZER_CONTRIBUTION_KILLSWITCH_SUCCESS:            
            setDownsizerContributionKillSwitch(action.killSwitch);
            break;               
        case ApplicationConstants.ActionTypes.DOWNSIZER_CONTRIBUTION_KILLSWITCH_ERROR:                        
            break;
        default:
            return true;
    }

    // If action was responded to, emit change event
    FundingYourProductStore.emitChange();
    return true;

});

module.exports = FundingYourProductStore;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./stores/FundingYourProductStore.js